const data = {
	"width": 48,
	"height": 48,
	"body": "<path fill=\"#43A047\" d=\"M40.6 12.1L17 35.7l-9.6-9.6L4.6 29L17 41.3l26.4-26.4z\"/>"
};
export default data;
